import { useHistory } from "react-router-dom";
import { remoteConfig } from '../firebase';



type LoggedInPaths = "HOME" | "ACTIVATION_CODE" | "SETTINGS" | "EDIT_PROFILE";
type LoggedOutPaths = "LOGIN" | "FORGET_PASSWORD" | "REGISTER";

export const useAuth = (
    currentPath: LoggedInPaths | LoggedOutPaths
): [boolean, (roomCode?: string) => void] => {
    let authorized = false;
    let redirectPath = "/";
    const history = useHistory();
    const user = JSON.parse(localStorage.getItem("UserFullData") as string);
    const redirect = (path: string) => {
        return (roomCode?: string) => {
            history.push(roomCode && path === '/login' ? `${path}/${roomCode}` : path);
        };
    };

    const is_sms_check = remoteConfig.getBoolean('is_check_sms');
    //const is_sms_check = true;
    if (user) {
        // const redirectToActivation = is_sms_check && !user.is_active;
        //console.log(is_sms_check, !user.is_active, redirectToActivation);

        // if (redirectToActivation) {
        //     authorized = currentPath === 'ACTIVATION_CODE';
        //     redirectPath = '/activation-code';
        // } else {
            authorized = ["HOME", "SETTINGS", "EDIT_PROFILE"].includes(currentPath);
            redirectPath = "/";
        // }
    }
    
    else {
        authorized = ["LOGIN", "FORGET_PASSWORD", "REGISTER"].includes(currentPath);
        redirectPath = "/login";
    }


    return [authorized, redirect(redirectPath)];

};
